export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType[CustomFieldType["TEXT"] = 1] = "TEXT";
    CustomFieldType[CustomFieldType["INTEGER"] = 2] = "INTEGER";
    CustomFieldType[CustomFieldType["FLOAT"] = 3] = "FLOAT";
    CustomFieldType[CustomFieldType["DATE"] = 4] = "DATE";
    CustomFieldType[CustomFieldType["BOOLEAN"] = 5] = "BOOLEAN";
    CustomFieldType[CustomFieldType["DROP_DOWN"] = 6] = "DROP_DOWN";
    CustomFieldType[CustomFieldType["URL"] = 7] = "URL";
})(CustomFieldType || (CustomFieldType = {}));
//# sourceMappingURL=custom-field-type.js.map